import { DateTime } from 'luxon';

export default {
  getTenderValue (tender) {
    const latestVersion = tender.tenderVersions[0];

    const sumOfBids = latestVersion.lots.reduce(
      (p, c) => p + (c.bid?.totalPrice ?? 0),
      0
    );
    const sumOfEstimatedLotValues = latestVersion.lots.reduce(
      (p, c) => p + (c.estimatedPrice ?? 0),
      0
    );

    if (latestVersion.sumOfTotalLotPrice > 10 || sumOfBids > 10) {
      return {
        field: 'sumOfTotalLotPrice',
        value: Math.max(
          latestVersion.sumOfTotalLotPrice ?? 0,
          sumOfBids
        )
      };
    }

    if (
      latestVersion.sumOfEstimatedLotValues > 10 ||
          sumOfEstimatedLotValues > 10
    ) {
      return {
        field: 'sumOfEstimatedLotValues',
        value: Math.max(
          latestVersion.sumOfEstimatedLotValues ?? 0,
          sumOfEstimatedLotValues
        )
      };
    }

    if (latestVersion.value > 10) {
      return {
        field: 'value',
        value: latestVersion.value
      };
    }

    if (latestVersion.estimatedValue > 10) {
      return {
        field: 'estimatedValue',
        value: latestVersion.estimatedValue
      };
    }

    return {
      field: null,
      value: null
    };
  },

  getLotValue (tender, lot) {
    const latestVersion = tender.tenderVersions[0];

    if (lot.bid?.totalPrice > 10) {
      return {
        field: 'lot.bid.totalPrice',
        value: lot.bid.totalPrice
      };
    }

    if (lot.estimatedPrice > 10) {
      return {
        field: 'lot.estimatedPrice',
        value: lot.estimatedPrice
      };
    }

    if (latestVersion.value > 10) {
      return {
        field: 'value',
        value: latestVersion.value
      };
    }

    if (latestVersion.estimatedValue > 10) {
      return {
        field: 'estimatedValue',
        value: latestVersion.estimatedValue
      };
    }

    return {
      field: null,
      value: null
    };
  },

  getLocation (tender, lot) {
    const currentLot = lot !== undefined ? tender.tenderVersions[0].lots.find(x => x.lotNumber === lot) : tender.tenderVersions[0].lots[0];
    return [...currentLot.nuts].sort(
      (a, b) => a.code.length - b.code.length
    )[0];
  },

  getDate (tender, lot) {
    const currentLot = lot !== undefined ? tender.tenderVersions[0].lots.find(x => x.lotNumber === lot) : tender.tenderVersions[0].lots[0];

    if (!currentLot) {
      return {
        date: null,
        label: null
      };
    }

    if (tender.status === 'Expected') {
      const today = DateTime.now().startOf('day').toJSDate();

      // get the first ExtensionDate or EndDate after today from sortedDates
      const dates = [...currentLot.planningItems].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      ).filter(
        x => x.type === 'ExtensionDate' || x.type === 'EndDate'
      );

      const date = [...dates].reverse().find(x => new Date(x.date) > today);

      if (date) {
        return {
          date: date?.date,
          label: date.type === 'ExtensionDate' ? `Eerst volgende verlenging staat gepland op ${DateTime.fromISO(date?.date).toFormat('d MMM yyyy', { locale: 'nl' })}` : `De einddatum van de overeenkomst staat gepland op ${DateTime.fromISO(date?.date).toFormat('d MMM yyyy', { locale: 'nl' })}`
        };
      } else {
        const endDate = dates.find(x => x.type === 'EndDate');
        return {
          date: endDate?.date,
          label: endDate ? `De einddatum van de overeenkomst staat gepland op ${DateTime.fromISO(endDate?.date).toFormat('d MMM yyyy', { locale: 'nl' })}` : ''
        };
      }
    }
    const deadline = currentLot.planningItems.find(x => x.type === 'ApplicationDeadlineDate');
    return {
      date: deadline?.date,
      label: deadline ? `Deadline ${tender.status === 'Closed' ? 'stond' : 'staat'} gepland op ${DateTime.fromISO(deadline?.date).toFormat('d MMM yyyy', { locale: 'nl' })}` : ''
    };
  }
};
